/* JG bag drawer behaviour (2 Oct 2026).
   Sits on top of Dawn's stock cart-drawer. assets/cart.js, assets/cart-drawer.js and assets/product-form.js are untouched.

   What it adds
   1. Free gift rule. Liquid (snippets/cart-drawer.liquid) works out what the bag needs and prints it as
      data-jg-gift="add|fix|remove|ok" on .jg-bag. This script only carries out that instruction. The threshold lives in
      Theme settings > JG bag, never in here.
   2. Ring box one tap add (button [data-jg-box-add] inside the drawer). The paid studs row (JG gift closed) uses the
      same button with data-jg-upsell="bag-studs".
   3. A fresh copy of the bag every time it opens from the header icon, on page load, after a back/forward restore
      and when the tab comes back into view (the bag may have changed in another tab).
   4. Opens the bag when the URL has bag=open (the /cart page redirects there).
   5. html.jg-bag-open while the bag is open (hides the sticky add bar, see jg-bag.css).
   6. After a quantity request that got no answer, the steppers go back to the true numbers.

   Rules it keeps
   - One request of its own in flight at a time (a promise queue).
   - At most 2 corrective gift requests per bag change, so it can never loop.
   - It never talks to checkout.

   For other scripts: window.JGBag.add(items, { source, open }), window.JGBag.refresh(), window.JGBag.open().
   cart-drawer.renderContents(state) also works with or without state.sections. */
(function () {
  'use strict';
  if (window.JGBag) return;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var MAX_FIXES = 2;
  var TIMEOUT = 10000;

  var chain = Promise.resolve();
  var depth = 0; // jobs queued or running
  var waiting = null; // a refresh job that has not started yet
  var handled = new WeakSet(); // response objects this script has already dealt with
  var log = []; // last requests made by this script, for QA

  function drawer() {
    return document.querySelector('cart-drawer');
  }
  function frame(scope) {
    return scope ? scope.querySelector('[data-jg-bag]') : null;
  }
  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }
  function parse(html) {
    return new DOMParser().parseFromString(html || '', 'text/html');
  }
  function read(el) {
    if (!el) return null;
    var d = el.dataset;
    return {
      gift: d.jgGift || 'ok',
      giftId: Number(d.jgGiftId) || 0,
      keys: (d.jgGiftKeys || '').split(',').filter(Boolean),
      count: Number(d.jgCount) || 0,
      sig: d.jgSig || '',
    };
  }
  function readSections(sections) {
    return sections && sections['cart-drawer'] ? read(frame(parse(sections['cart-drawer']))) : null;
  }

  function request(method, path, body, kind) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl
      ? setTimeout(function () {
          ctrl.abort();
        }, TIMEOUT)
      : null;
    var opts = {
      method: method,
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    if (ctrl) opts.signal = ctrl.signal;
    log.push({ t: Date.now(), kind: kind, method: method, path: path });
    if (log.length > 60) log.shift();
    return fetch(path, opts)
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok && !(data && data.status), data: data };
        });
      })
      .catch(function (error) {
        return { ok: false, data: null, error: error };
      })
      .then(function (res) {
        if (timer) clearTimeout(timer);
        return res;
      });
  }
  function fetchSections() {
    // Not routes.cart_url: /cart answers a JSON request with the cart object and ignores ?sections.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return request('GET', root + '?sections=' + SECTIONS.join(','), null, 'refresh').then(function (res) {
      if (res.ok && !(res.data && res.data['cart-drawer'])) res.ok = false;
      return res;
    });
  }

  /* ---------- waiting for Dawn's own quantity request ---------- */
  function stockBusy() {
    var d = drawer();
    if (!d) return false;
    if (d.querySelector('#CartDrawer-CartItems.cart__items--disabled')) return true;
    var inputs = d.querySelectorAll('.jg-bag__qty input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== inputs[i].getAttribute('value')) return true; // a change is waiting on Dawn's 300ms debounce
    }
    return false;
  }
  function stockIdle() {
    return new Promise(function (resolve) {
      var n = 0;
      (function tick() {
        if (!stockBusy() || n++ > 60) return resolve();
        setTimeout(tick, 50);
      })();
    });
  }

  /* ---------- painting ---------- */
  function busy(on) {
    var d = drawer();
    if (d) d.classList.toggle('jg-bag--busy', !!on);
  }
  function giftOff(on) {
    var d = drawer();
    if (d) d.classList.toggle('jg-bag--nogift', !!on);
  }
  function syncEmpty() {
    var d = drawer();
    var m = d ? read(frame(d)) : null;
    if (m) d.classList.toggle('is-empty', m.count === 0);
  }
  // A quantity request that failed leaves the number the shopper tapped in the stepper. Put the bag's own numbers back.
  function resetSteppers() {
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('.jg-bag__qty input').forEach(function (input) {
      var value = input.getAttribute('value');
      if (input.value !== value) input.value = value;
    });
  }
  function clearErrors() {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el && el.textContent) el.textContent = '';
  }
  function apply(sections, keepErrors) {
    var d = drawer();
    if (!d || !sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var src = parse(html).querySelector('.drawer__inner');
      var dst = d.querySelector('.drawer__inner');
      if (src && dst) {
        var now = read(frame(dst));
        var next = read(frame(src));
        if (!now || !next || now.sig !== next.sig) {
          var scroller = dst.querySelector('cart-drawer-items');
          var top = scroller ? scroller.scrollTop : 0;
          dst.innerHTML = src.innerHTML;
          scroller = dst.querySelector('cart-drawer-items');
          if (scroller && top) scroller.scrollTop = top;
          if (d.classList.contains('active') && typeof trapFocus === 'function') {
            try {
              trapFocus(document.getElementById('CartDrawer'), dst);
            } catch (e) {}
          }
        } else if (!keepErrors) {
          clearErrors(); // same bag, read again from the shop: an old "could not update" line no longer applies
        }
      }
    }
    var bubbleHtml = sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var fresh = parse(bubbleHtml).querySelector('.shopify-section');
      if (fresh && fresh.innerHTML !== bubble.innerHTML) bubble.innerHTML = fresh.innerHTML;
    }
    syncEmpty();
  }
  // Shopify's own stock message says "cart". The store says "bag".
  function bagWording() {
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('.cart-item__error-text, #CartDrawer-CartErrors').forEach(function (el) {
      if (/cart/i.test(el.textContent)) el.textContent = el.textContent.replace(/\bcart\b/g, 'bag').replace(/\bCart\b/g, 'Bag');
    });
  }
  function openDrawer(trigger) {
    var d = drawer();
    if (!d || typeof d.open !== 'function' || d.classList.contains('active')) return;
    d.open(trigger);
  }

  /* ---------- the gift rule ---------- */
  function fixGift(m) {
    var base = { sections: SECTIONS, sections_url: window.location.pathname };
    if (m.gift === 'add') {
      if (!m.giftId) return Promise.resolve({ ok: false, data: null });
      return request(
        'POST',
        route('cart_add_url', '/cart/add') + '.js',
        Object.assign({ items: [{ id: m.giftId, quantity: 1 }] }, base),
        'gift-add'
      );
    }
    var updates = {};
    m.keys.forEach(function (key, i) {
      updates[key] = m.gift === 'fix' && i === 0 ? 1 : 0;
    });
    return request(
      'POST',
      route('cart_update_url', '/cart/update') + '.js',
      Object.assign({ updates: updates }, base),
      'gift-' + m.gift
    );
  }
  async function settleGift(sections, m) {
    var fixes = 0;
    while (m && m.gift !== 'ok' && fixes < MAX_FIXES) {
      fixes++;
      await stockIdle();
      var res = await fixGift(m);
      if (!res.ok || !res.data || !res.data.sections) {
        if (m.gift === 'add') giftOff(true);
        return sections;
      }
      sections = res.data.sections;
      m = readSections(sections);
    }
    if (m && m.gift === 'ok') giftOff(false);
    return sections;
  }

  /* ---------- the queue ---------- */
  function enqueue(task) {
    depth++;
    busy(true);
    var run = chain.then(task);
    chain = run
      .catch(function () {})
      .then(function () {
        depth--;
        if (!depth) busy(false);
      });
    return run;
  }
  async function run(opts) {
    try {
      var sections = opts.state && opts.state.sections && opts.state.sections['cart-drawer'] ? opts.state.sections : null;
      var m = sections ? readSections(sections) : null;
      if (!m && opts.dom) m = read(frame(drawer()));
      if (!m) {
        var res = await fetchSections();
        if (!res.ok || !res.data) return;
        sections = res.data;
        m = readSections(sections);
      }
      sections = await settleGift(sections, m);
      if (sections) apply(sections, opts.keepErrors);
      if (opts.open) openDrawer();
    } catch (e) {
      console.error('[jg-bag]', e);
    }
  }
  /* Bring the drawer in line with the real bag and carry out the gift rule.
     opts.state: a response that carries sections (skips the fetch). opts.dom: trust the markup on the page. opts.open: open after.
     opts.keepErrors: leave the "could not update" line on screen (used right after a failed request). */
  function settle(opts) {
    opts = opts || {};
    if (waiting) {
      waiting.opts.state = null;
      waiting.opts.dom = false;
      if (opts.open) waiting.opts.open = true;
      if (opts.keepErrors) waiting.opts.keepErrors = true;
      return waiting.promise;
    }
    var stale = depth > 0; // something is already running, so whatever the caller holds may be out of date
    var job = {
      opts: { state: stale ? null : opts.state, dom: stale ? false : opts.dom, open: opts.open, keepErrors: opts.keepErrors },
    };
    waiting = job;
    job.promise = enqueue(function () {
      waiting = null;
      return run(job.opts);
    });
    return job.promise;
  }
  /* Add lines to the bag, settle the gift in the same pass, paint once, open, and tell the rest of the theme. */
  function add(items, opts) {
    opts = opts || {};
    return enqueue(async function () {
      await stockIdle();
      var res = await request(
        'POST',
        route('cart_add_url', '/cart/add') + '.js',
        { items: items, sections: SECTIONS, sections_url: window.location.pathname },
        'add'
      );
      if (!res.ok || !res.data) {
        var err = new Error((res.data && (res.data.description || res.data.message)) || 'The bag could not be updated');
        err.response = res.data;
        throw err;
      }
      var sections = res.data.sections;
      if (!sections || !sections['cart-drawer']) {
        var again = await fetchSections();
        sections = again.ok ? again.data : null;
      }
      sections = await settleGift(sections, readSections(sections));
      var state = Object.assign({}, res.data, { sections: sections });
      handled.add(state);
      apply(sections);
      if (opts.open !== false) openDrawer(opts.trigger);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: opts.source || 'jg-bag', cartData: state });
      }
      return state;
    });
  }

  /* ---------- wiring ---------- */
  function init() {
    var Drawer = customElements.get('cart-drawer');
    var Items = customElements.get('cart-drawer-items');
    if (!Drawer || !drawer()) return;

    // 1. Adds from the product form (and anything else that calls renderContents): paint at once, then settle the gift.
    //    The first paint already shows the gift band, because Liquid draws it from the bag value.
    var stockRender = Drawer.prototype.renderContents;
    Drawer.prototype.renderContents = function (state) {
      if (state && typeof state === 'object') handled.add(state);
      if (!state || !state.sections || !state.sections['cart-drawer']) {
        settle({ open: true });
        return;
      }
      stockRender.call(this, state);
      syncEmpty();
      settle({ state: state });
    };

    // 2. Dawn's own refetch on cartUpdate swaps only part of the drawer and can land after ours with older line numbers.
    //    This script does the full refresh instead (see the subscription below).
    if (Items) {
      Items.prototype.onCartUpdate = function () {
        return Promise.resolve();
      };

      // 2b. A quantity request that got no answer (offline, timed out, throttled). Dawn prints its error line but leaves the
      //     number the shopper tapped in the stepper, and the next tap would build on it. disableLoading runs at the end of
      //     every such request, after that error line is written. Put the true numbers back and read the bag again.
      var stockDisable = Items.prototype.disableLoading;
      Items.prototype.disableLoading = function () {
        stockDisable.apply(this, arguments);
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && errors.textContent) {
          resetSteppers();
          settle({ keepErrors: true });
        }
      };
    }

    // 3. Every bag change that goes through the theme's event bus.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source === 'jg-bag') return;
        var data = event.cartData;
        if (data && typeof data === 'object' && handled.has(data)) return;
        var state = data && data.sections && data.sections['cart-drawer'] ? data : null;
        if (event.source === 'cart-items') {
          // Dawn has just painted this response after a quantity change or a remove
          if (data && data.errors) bagWording();
          syncEmpty();
          settle({ state: state });
          return;
        }
        // product-form publishes first and calls renderContents in the same tick. Give it that tick.
        setTimeout(function () {
          if (data && typeof data === 'object' && handled.has(data)) return;
          settle({ state: state });
        }, 0);
      });
    }

    // 4. Header icon: Dawn opens the drawer, this fetches a fresh copy behind it.
    document.addEventListener(
      'click',
      function (event) {
        var icon = event.target && event.target.closest ? event.target.closest('#cart-icon-bubble') : null;
        if (icon) settle({});
      },
      true
    );

    // 5. Ring box one tap add.
    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-jg-box-add]') : null;
      if (!btn) return;
      event.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var id = Number(btn.dataset.variantId);
      if (!id) return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-busy');
      // data-jg-upsell tells upsells apart in order data (paid studs row: bag-studs). The ring box keeps 'bag'.
      add([{ id: id, quantity: 1, properties: { __jg_upsell: btn.dataset.jgUpsell || 'bag' } }], {
        source: 'jg-bag',
        open: false,
      })
        .catch(function () {
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
        })
        .then(function () {
          if (btn.isConnected) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('is-busy');
          }
        });
    });

    // 6. html.jg-bag-open mirrors the drawer.
    var d = drawer();
    var mirror = function () {
      document.documentElement.classList.toggle('jg-bag-open', d.classList.contains('active'));
    };
    new MutationObserver(mirror).observe(d, { attributes: true, attributeFilter: ['class'] });
    mirror();

    // 7. Page load: the markup is fresh from the server, so read it and fix the gift if needed.
    syncEmpty();
    settle({ dom: true });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) settle({});
    });
    // 7b. Back on this tab: the bag may have changed in another tab, and a drawer left open here would act on old line numbers.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') settle({});
    });

    // 8. bag=open in the URL.
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('bag') === 'open') {
        params.delete('bag');
        var query = params.toString();
        window.history.replaceState(
          window.history.state,
          '',
          window.location.pathname + (query ? '?' + query : '') + window.location.hash
        );
        openDrawer();
      }
    } catch (e) {}
  }

  window.JGBag = {
    add: add,
    refresh: function (opts) {
      return settle(opts || {});
    },
    open: function (trigger) {
      openDrawer(trigger);
      return settle({});
    },
    close: function () {
      var d = drawer();
      if (d && typeof d.close === 'function') d.close();
    },
    log: log,
  };

  if (window.customElements && customElements.whenDefined) {
    Promise.all([customElements.whenDefined('cart-drawer'), customElements.whenDefined('cart-drawer-items')]).then(init);
  }
})();
